const PRODUCT_DATA = [
  {
    id: 1,
    price: 18,
    name: "Charli3",
    productDesc: null,
    type: "single",
    bundleName: "Tubular",
    bundleDesc: "",
    bundleIncludes: null,

  },
  // {
  //   id: 3,
  //   price: 75,
  //   name: "Canuckz",
  //   productDesc: null,
  //   type: "quintet",
  //   bundleName: "Quality Quintet",
  //   bundleDesc: "Five Canuckz NFTs with TWO guaranteed green rarity or better!",
  //   bundleIncludes: ["5x Random Canuckz", "2 guaranteed green or better rarity"],
  //   highlighted: true

  // },
  // {
  //   id: 4,
  //   price: 120,
  //   name: "Canuckz",
  //   type: "gargantuan",
  //   productDesc: null,
  //   bundleName: "The Gargantuan",
  //   bundleDesc: "Go big or go home. The ultimate pack of Canuckz NFTs.",
  //   bundleIncludes: ["10x Random Canuckz", "1 blue + 3 green guaranteed rarity"],

  // },

];

export default PRODUCT_DATA;